import React, { useState } from 'react';
import { useComponents } from '@tencent/dz-elements';
import { useMessageModel, useMessageById, useMobileModel } from '../../../hooks';
import { FormContainer, FormItem, PhoneItem } from '../../../components';
import { useReportService } from './useReportService';
import { isValidPhone } from '../../../utils';
var QuickPhone = function (props) {
    var _a;
    var View = useComponents().View;
    var _b = useMobileModel(), mobile = _b.mobile, autoPhoneEnabled = _b.autoPhoneEnabled;
    var messageModel = useMessageModel();
    var messageState = useMessageById(props.messageId);
    var _c = useState(mobile), phone = _c[0], setPhone = _c[1];
    var _d = useState(true), valid = _d[0], setValide = _d[1];
    var _e = useState(false), modalVisible = _e[0], setModalVisible = _e[1];
    var _f = useState(false), checked = _f[0], setChecked = _f[1];
    var report = useReportService(props.messageId);
    var handlePhoneChange = function (value) {
        setValide(isValidPhone(value));
        setPhone(value);
    };
    var onSubmitPhone = function (checked) {
        // 能获取到手机号且checkbox未选中时
        if (autoPhoneEnabled && !checked) {
            setModalVisible(true);
            report.quickPhonePopupExposure();
            return;
        }
        setChecked(true);
        if (!phone || !valid) {
            return;
        }
        messageModel.sendFormMessage({
            phone: phone,
            msgType: messageState.type,
        });
        report.quickPhoneSubmit(phone);
    };
    var hanldePopupOk = function () {
        setChecked(true);
        setModalVisible(false);
        onSubmitPhone(true);
        report.quickPhonePopupSubmit(phone);
    };
    var hanldePopupCancel = function () {
        setModalVisible(false);
        report.quickPhonePopupCancel();
    };
    var handleToggle = function (value) {
        report.quickPhoneClauseClick(value);
        setChecked(value);
    };
    return (React.createElement(View, { id: ((_a = messageState.payload) === null || _a === void 0 ? void 0 : _a.is_offline) ? 'offline_message' : 'message' },
        React.createElement(FormContainer, { title: "\u4E00\u952E\u53D1\u9001\u7535\u8BDD\u53F7\u7801" },
            React.createElement(FormItem, null,
                React.createElement(PhoneItem, { handlePhoneChange: handlePhoneChange, phone: phone, btnText: "\u53D1\u9001", onSubmitPhone: onSubmitPhone, modalVisible: modalVisible, checked: checked, buttonVisible: true, valid: valid, hanldePopupCancel: hanldePopupCancel, handleToggle: handleToggle, hanldePopupOk: hanldePopupOk })))));
};
export default QuickPhone;
